import { com, kotlin } from '@eidu/web'
import entityApiUrl from '../baseUrl'
import permissionGrantDTO, { PermissionGrantDTO } from '../../../../domain/permission/PermissionGrantDTO'
import fetchAuthorized from '../../authorization/fetchAuthorized'
import serializeToJsonString = com.eidu.sharedlib.entity.util.serializeToJsonString
import Permission = com.eidu.sharedlib.entity.permission.Permission
import PermissionPolicyId = com.eidu.sharedlib.entity.permission.PermissionPolicyId
import CreatePermissionGrantRequest = com.eidu.sharedlib.entity.api.permissions.CreatePermissionGrantRequest
import PermissionGrant = com.eidu.sharedlib.entity.permission.PermissionGrant
import KtSet = kotlin.collections.KtSet
import EntitySelector = com.eidu.sharedlib.entity.selector.EntitySelector

export type CreatePermissionGrantParameters = {
  userSelector: EntitySelector
  permissions: readonly Permission[]
  policyIds: readonly PermissionPolicyId[]
}

const createPermissionGrant = async ({
  userSelector,
  permissions,
  policyIds,
}: CreatePermissionGrantParameters): Promise<PermissionGrantDTO> => {
  return fetchAuthorized(
    (authContext) => `${entityApiUrl}/organizations/${authContext.organizationId}/permissions/grants`,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: serializeToJsonString(
        new CreatePermissionGrantRequest(
          new PermissionGrant(userSelector, KtSet.fromJsSet(new Set(permissions)), KtSet.fromJsSet(new Set(policyIds)))
        )
      ),
      method: 'POST',
    }
  ).then(async (response) => {
    if (response.status !== 201)
      throw Error(`Unexpected response code ${response.status} from createPermissionGrant endpoint`)
    return permissionGrantDTO((await response.json()).document)
  })
}

export default createPermissionGrant
